import React, { Component } from 'react'
import { TABLA_CAMIONES_VOLCADOS } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

export class TablaCamionesVolcadosView extends Component {
  render () {
    return (
      <MuiTable id={TABLA_CAMIONES_VOLCADOS} />
    )
  }
}
